<script setup lang="ts">
import { Property, propertyIcon, propertyName } from "~/classes/entity"

const { state: viewModeState,propertySortOptions, addViewModeSort, removeViewModeSort, changeViewModeSort } = useViewMode()
const { columnStyle } = useTableView()
const { collectionTableDraggerClass } = useGlobals()

/** Cycles between no-sort, ascending, descending */
function onClickedSort(propertyId: Property) {
  const options = propertySortOptions(propertyId)
  if (!isDefined(options))
    addViewModeSort({ propertyId, descending: false })
  else if (!options.descending)
    changeViewModeSort({ propertyId, descending: true })
  else
    removeViewModeSort(propertyId)
}
</script>

<template>
  <div class="header-table">
    <div
      v-for="show, index in viewModeState.current.show"
      :key="index"
      class="header-column"
      :style="columnStyle(index)"
    >
      <div v-if="enumEq(show.propertyId, Property.FILE_VIRTUAL_PREVIEW)" />
      <div
        v-else
        class="header-name"
        @click="onClickedSort(show.propertyId)"
      >
        <icon-property
          :type="propertyIcon(show.propertyId)"
          size="2xs"
          class="icon"
        />
        <div class="name">
          {{ propertyName(show.propertyId) }}
        </div>
        <icon-action
          v-if="propertySortOptions(show.propertyId)"
          :type="propertySortOptions(show.propertyId)?.descending ? 'arrow-down' : 'arrow-up'"
          size="2xs"
          class="sort"
        />
      </div>
      <div
        v-if="index > 0"
        class="header-resizer"
        :class="collectionTableDraggerClass"
        :data-table-index="index"
      >
        <div class="inner" />
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'
.header-table
  @apply flex border-b-[#{$page-table-b-separator}] border-b-2 px-[#{$page-table-p-main}] h-[#{$page-table-h-header}] items-center
.header-column
  @apply flex-shrink-0
  @apply relative

.header-resizer
  @apply absolute right-0 top-0 bottom-0
  @apply flex-none h-full px-1
  @apply cursor-ew-resize
  .inner
    @apply h-full w-full flex-none
  &:hover .inner
    @apply border-r-2.5 border-r-$global-blue-primary

.header-name
  @apply inline-flex items-center gap-1
  @apply cursor-pointer
  @apply px-1 rounded-[#{$global-br-xs}]
  .name
    @apply text-[#{$global-t-tertiary}]
  .icon
    @apply text-[#{$global-bg-icon-secondary}]
  &:hover
    @apply bg-[#{$menu-bg-item-hover}]
</style>
